import {useCallback,useEffect,useRef,useState} from 'react';

const action=Symbol('content-link-action');
/** An in-memory user action, scoped to one identity and cancelled when its owner retires. */
export interface ContentLinkIntent {readonly [action]:true;readonly identity:string;readonly mediaId?:string;readonly serial:number;readonly signal:AbortSignal}
interface Owned {intent:ContentLinkIntent;controller:AbortController}
function create(identity:string,serial:number,mediaId?:string):Owned{
 const controller=new AbortController();return {controller,intent:{[action]:true,identity,serial,mediaId,signal:controller.signal}};
}
/** initial is reserved for a viewer mounted by an explicit Open action. */
export function useContentLinkIntent(identity:string,initial=false){
 const [state,setState]=useState(()=>({identity,serial:0,owned:initial?create(identity,0):undefined as Owned|undefined}));
 if(state.identity!==identity){state.owned?.controller.abort();setState({identity,serial:state.serial+1,owned:undefined});}
 const lifetime=useRef({version:0});
 useEffect(()=>{
  const lifecycle=lifetime.current,current=++lifecycle.version,owned=state.owned;
  return()=>{void Promise.resolve().then(()=>{if(lifecycle.version===current)owned?.controller.abort();});};
 },[state.owned]);
 const activate=useCallback((mediaId?:string)=>{setState(previous=>{previous.owned?.controller.abort();const serial=previous.serial+1;return {identity,serial,owned:create(identity,serial,mediaId)};});},[identity]);
 const clear=useCallback(()=>{setState(previous=>{previous.owned?.controller.abort();return {...previous,owned:undefined};});},[]);
 return {intent:state.identity===identity?state.owned?.intent:undefined,activate,clear};
}
